import Vue from "vue";
import datePicker from "vue-bootstrap-datetimepicker";
// import 'bootstrap/dist/css/bootstrap.css';
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

import "@fortawesome/fontawesome-free/js/all.js";

Vue.use(datePicker);
